import { Box, Button, Flex, Input, InputGroup, InputLeftElement, Text } from '@chakra-ui/react';
import { ReactComponent as CopyLinkIcon } from 'assets/icons/share_link.svg';
import { useVenngageE1Gate } from 'hooks/useVenngageE1Gate';
import { useId, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { isStandalone } from 'utils/environment';

type SharePrivateLinkProps = {
  disabled?: boolean;
  onCopyLink?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
};

export const SharePreviewLink = ({ disabled = false, onCopyLink = () => {} }: SharePrivateLinkProps) => {
  const { t } = useTranslation('common_navbar');
  const { id } = useParams();
  const { venngageE2 } = useVenngageE1Gate();
  const sharePrivateLinkUrl = useId();

  const privateLinkURL = useMemo(() => {
    const shareLinkId = isStandalone ? id : venngageE2?.privateLinkId;
    const fakeId = '123456abc'; // This fake ID is the same with the e1
    const result = new URL(`${window.location.origin}/pl/${disabled ? fakeId : shareLinkId}`).toString();

    return result;
  }, [disabled, id, venngageE2]);

  const sharePrivateLinkTestId = 'share-private-link';
  const sharePrivateLinkInputTestId = 'share-private-link-copy-link-input';
  const sharePrivateLinkCopyLinkTestId = 'share-private-link-copy-link-button';

  return (
    <Flex flexDir='column' gap='2' data-testid={sharePrivateLinkTestId}>
      <Text
        as={'label'}
        htmlFor={sharePrivateLinkUrl}
        fontWeight={'semibold'}
        fontSize='sm'
        lineHeight='1.25'
        color={'font.500'}
      >
        {t('modals.share-panel.share-preview-link.title')}
      </Text>
      <Text fontSize='xs' color={'font.300'}>
        {t('modals.share-panel.share-preview-link.subtitle')}
      </Text>
      <Flex gap='2'>
        <Box flexGrow={1}>
          <InputGroup>
            <InputLeftElement pointerEvents='none' pl='2' width='32px' height='32px' color='font.300'>
              <CopyLinkIcon width='20px' height='20px' />
            </InputLeftElement>
            <Input
              id={sharePrivateLinkUrl}
              isReadOnly
              size='sm'
              textOverflow={'ellipsis'}
              disabled={disabled}
              value={privateLinkURL}
              data-testid={sharePrivateLinkInputTestId}
              borderRadius={'base'}
            />
          </InputGroup>
        </Box>
        <Button
          onClick={onCopyLink}
          disabled={disabled}
          variant='action'
          size='sm'
          width='24'
          data-testid={sharePrivateLinkCopyLinkTestId}
        >
          {t('modals.share-panel.copy-link')}
        </Button>
      </Flex>
    </Flex>
  );
};
